<div class="title-section" [class.darkmode]="darkMode">
  <button *ngIf="allowGoBack" class="button-back" [class.is-webview]="isWebview" (click)="goBack()">
    <i class="app-icon-back button-back__icon"></i>
  </button>
  <div class="title-container" [class.d-none]="isWebview">
    <h1 class="u-h1">{{ text }}</h1>
    <a class="link" (click)="goToLink()">{{ textLink }}</a>
  </div>
</div>
